import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { lewisvilleConfig } from "./data";

export default function LewisvillePage() {
  return <CityPageTemplate config={lewisvilleConfig} />;
}